export const MOBILE_MAX_WIDTH = 768;
export const MOBILE_FIXED_WIDTH = 450;
export const HEADER_HEIGHT = 64;
export const FOOTER_HEIGHT = 70;
export const PAGE_PADDING = 24;
export const BOTTOM_BTN_HEIGHT = 80;

// 공통코드 - 부모코드명
export const COMMON_CODE_NAME = {
  ACNT_STTS_CD: 'ACNT_STTS_CD',
  GENDER_TYPE_CD: 'GENDER_TYPE_CD',
  USER_TYPE_CD: 'USER_TYPE_CD',
  TERMS_TYPE_CD: 'TERMS_TYPE_CD',
  HSPTL_CD: 'HSPTL_CD',
  MED_QST_TYPE_CD: 'MED_QST_TYPE_CD',
  MEDICINE_CD: 'MEDICINE_CD',
  ALARM_TYPE_CD: 'ALARM_TYPE_CD',
  MISSION_TYPE_CD: 'MISSION_TYPE_CD',
  FTND_RESULT_CD: 'FTND_RESULT_CD',
  CRAVING_TYPE_CD: 'CRAVING_TYPE_CD',
  FAQ_TYPE_CD: 'FAQ_TYPE_CD',
  OS_TYPE_CD: 'OS_TYPE_CD',
  FILTER_TYPE_CD: 'FILTER_TYPE_CD',
};

// 갈망 원인 카테고리 부모 코드
export const CRAVING_CATEGORY_PID = {
  SITUATION: 5900001,
  LOCATION: 5900002,
  WITH_WHOM: 5900003,
  EMOTION: 5900004,
} as const;

export type CravingCategoryPid = typeof CRAVING_CATEGORY_PID[keyof typeof CRAVING_CATEGORY_PID];

// 약관 유형 코드
export const TERMS_TYPE_CODE = {
  SERVICE: 4000001,
  PRIVACY_POLICY: 4000002,
  REGISTER: 4000003,
  MARKETING: 4000004,
};

// 사용자 유형 코드
export const USER_TYPE_CD = {
  USER: 1007001,
  ADMIN: 1007002,
  MEDICALSTAFF: 1007003,
};

// 챗봇 코드
export const CHATBOT_TYPE = {
  SPEAKER: {
    CHATBOT: 'chatbot',
    USER: 'user',
  },
  MISSION_CONV_TYPE: {
    MESSAGE: 'message',
    QUESTION: 'question',
    QUESTIONS: 'questions',
    END: 'end',
    RAG: 'RAG',
    CARD: 'card',
    PIECHART: 'piechart',
    SOS: 'sos',
    IMAGE: 'image',
    USER: 'user',
    HISTORY: 'history_',
    HISTORY_MESSAGE: 'history_message',
    HISTORY_USER: 'history_user',
    HISTORY_IMAGE: 'history_image',
    HISTORY_PIECHART: 'history_piechart',
  },
  USER_OPTION: {
    BUTTON: 'button',
    NAVIGATE_BUTTON: 'navigate_button', // 클릭 시 페이지 이동 버튼 (contentLinks)
    CHECKBOX: 'checkbox',
    TEXT: 'text',
    SLIDER: 'slider',
    CHECKBOX_: 'checkbox_', // 최소 선택 개수가 정해진 체크박스
  },
};

// 알림 유형 코드
export const ALARM_TYPE_CD = {
  MEDICINE: 5600001,
  MISSION: 5600002,
  DIARY: 5600003,
  CRAVING_REMINDER: 5600004,
  PATTERN_ANALYSIS: 5600005,
  CRAVING_HIGH: 5600006,
  CRAVING_MEDIUM: 5600007,
  CRAVING_LOW: 5600008,
};

// 문진 유형 코드
export const MED_QST_TYPE_CD = {
  BASICQUESTIONNAIRE: 5100001,
  DEMOGRAPHICINFORMATION: 5100002,
  SMOKINGINFORMATION: 5100003,
  QSU: 5100004,
  KSCMS: 5100005,
};

// 문진 - 흡연 유형 선택지 SID (medQstChoiceSid 기준)
// 흡연정보 섹션의 첫 질문(medQstSid=10) 선택지들과 매핑됨
export const SMOKING_TYPE_CHOICE_SID = {
  REGULAR_CIGARETTE: 31, // 일반 궐련 담배
  HEATED_TOBACCO: 154, // 궐련형 전자담배
  LIQUID_VAPE: 155, // 액상형 전자담배
} as const;

// 흡연 유형별 조건부 질문 개수 (medQstChoiceSid → 파생 질문 수)
// 흡연 유형 선택 시 추가로 노출되는 질문의 수
export const SMOKING_TYPE_QUESTION_COUNT: Record<number, number> = {
  [SMOKING_TYPE_CHOICE_SID.REGULAR_CIGARETTE]: 2, // 개비 수 + 시작 나이
  [SMOKING_TYPE_CHOICE_SID.HEATED_TOBACCO]: 2, // 개비 수 + 시작 나이
  [SMOKING_TYPE_CHOICE_SID.LIQUID_VAPE]: 3, // 회수 + 회당 분 + 시작 나이
};

// 갈망원인 유형 코드
export const CRAVING_TYPE_CD = {
  STRESS: {
    code: 5900001001,
    color: '#1E1C5D',
  },
  WORRY_DECISION: {
    code: 5900001002,
    color: '#3831A1',
  },
  WHEN_BORED: {
    code: 5900001003,
    color: '#554AEE',
  },
  WHEN_ANXIOUS: {
    code: 5900001004,
    color: '#756CF9',
  },
  WHEN_FEELING_LONELY: {
    code: 5900001005,
    color: '#034387',
  },
  DRINKING_OCCASIONS: {
    code: 5900002001,
    color: '#05529F',
  },
  DURING_MEALS: {
    code: 5900002002,
    color: '#0468C8',
  },
  TOBACCO_OFFER: {
    code: 5900002004,
    color: '#2E96F9',
  },
  AROUND_SMOKERS: {
    code: 5900002003,
    color: '#1A808C',
  },
  NICOTINE_WITH_DRAWAL_SYMPTOMS: {
    code: 5900004001,
    color: '#20A4B1',
  },
  NICOTIN_DEPENDENCE_CRAVING: {
    code: 5900004002,
    color: '#2FB49F',
  },
  HABITUALLY: {
    code: 5900003003,
    color: '#FF643C',
  },
  UPON_WAKING_UP_IN_THE_MORNING: {
    code: 5900003001,
    color: '#F9CA32',
  },
  AFTER_MEALS: {
    code: 5900003002,
    color: '#FFA127',
  },
  IN_HAPPY_JOYFUL_SITUATIONS: {
    code: 5900001006,
    color: '#D20540',
  },
  BREAK_TIME: {
    code: 5900003004,
    color: '#FD4583',
  },
};

// 복용약 정보 (DB 데이터 기반)
export const DRUG_INFO = {
  NICOCHAMPS: {
    medicineNm: '니코챔스',
    drugInfoSid: 1,
  },
  NICOPION: {
    medicineNm: '니코피온',
    drugInfoSid: 2,
  },
  NONE: {
    medicineNm: '없음',
    drugInfoSid: 3,
  },
};

// chatbot piechart color
export const CHATBOT_CHART_COLOR = [
  {
    code: '5900001001',
    color: '#1E1C5D',
  },
  {
    code: '5900001002',
    color: '#3831A1',
  },
  {
    code: '5900001003',
    color: '#554AEE',
  },
  {
    code: '5900001004',
    color: '#756CF9',
  },
  {
    code: '5900001005',
    color: '#034387',
  },
  {
    code: '5900002001',
    color: '#05529F',
  },
  {
    code: '5900002002',
    color: '#0468C8',
  },
  {
    code: '5900002004',
    color: '#2E96F9',
  },
  {
    code: '5900002003',
    color: '#1A808C',
  },
  {
    code: '5900004001',
    color: '#20A4B1',
  },
  {
    code: '5900004002',
    color: '#2FB49F',
  },
  {
    code: '5900003003',
    color: '#FF643C',
  },
  {
    code: '5900003001',
    color: '#F9CA32',
  },
  {
    code: '5900003002',
    color: '#FFA127',
  },
  {
    code: '5900001006',
    color: '#D20540',
  },
  {
    code: '5900003004',
    color: '#FD4583',
  },
  {
    code: '1',
    color: '#FFDC1B',
  },
  {
    code: '2',
    color: '#26A4F4',
  },
  {
    code: '3',
    color: '#FC8F59',
  },
  {
    code: '4',
    color: '#32BDAD',
  },
  {
    code: '5',
    color: '#4F7AFB',
  },
  {
    code: '6',
    color: '#FF7CAE',
  },
];

/** @deprecated SID는 언어별로 다르므로 CRAVING_SOS_CONTS_TYPE 사용 권장 */
export const CRAVING_SOS_CONTS_SID = {
  RELAXATION: 1,
  BREATH: 2,
  MULTIPLICATION_TABLES: 3,
  ENDURE: 4,
  DRINK_WATER: 5,
  SOCIAL_SUPPORTER: 6,
};

// imgPath 파일명 기반 컨텐츠 타입 식별 (언어 독립적)
export const CRAVING_SOS_CONTS_TYPE = {
  RELAXATION: 'relaxation',
  BREATH: 'breath',
  MULTIPLICATION_TABLES: 'multiplication-tables',
  ENDURE: 'endure',
  DRINK_WATER: 'drink-water',
  SOCIAL_SUPPORTER: 'social-supporter',
} as const;

// imgPath에서 컨텐츠 타입 추출
export function getCravingContentsType(imgPath: string): string {
  const fileName = imgPath.replace(/^.*\//, '').replace(/\.\w+$/, '');
  return fileName;
}

export const COMMON_CODE_PID = {
  CRAVING_TYPE_CD: 5900,
};

export const SERVICE_CONTROL_PAGE_PATH = {
  login: 'login',
  findId: 'find-id',
  resetPwd: 'reset-pwd',
  register: 'register',
  verification: 'verification',
  home: 'home',
  drJin: 'drJin',
  missionHistory: 'mission-history',
  missionHistoryDetail: 'mission-history-detail',
  missionDetail: 'mission-detail',
  craving: 'craving',
  cravingRecord: 'craving-record',
  calendar: 'calendar',
  myPage: 'my-page',
  quitSmokingDiary: 'quit-smoking-diary',
  cravingDiary: 'craving-diary',
  quitSmokingAim: 'quit-smoking-aim',
  editProfile: 'edit-profile',
  editMemberInfo: 'edit-member-info',
  termsSettings: 'termsSettings',
  notificationSettings: 'notification-settings',
  faq: 'faq',
  version: 'version',
  privacyPolicy: 'privacyPolicy',
  service: 'service',
  appGuide: 'app-guide',
  supporter: 'supporter',
  ftnd: 'ftnd',
  medicalQuestion: 'medical-question',
  drugQuestion: 'drug-question',
  medicineSettings: 'medicine-settings',
  languageSettings: 'language-settings',
  personaSettings: 'persona-settings',
};

export const LANGUAGE = {
  korean: 'ko',
  english: 'en',
  deutsch: 'de',
};
